import { Navigate } from 'react-router-dom'

import AuthGuard from '../../auth/AuthGuard'
import MatxLayout from '../base/components/Template/MatxLayout/MatxLayout'
import { CajasProvider } from '../base/contexts/CajasContext'
import { OperacionesProvider } from '../base/contexts/OperacionesContext'
import cuentaRoutes from '../modules/base/cuenta/CuentaRoutes'
import NotFound from '../modules/base/sessions/NotFound'
import sessionRoutes from '../modules/base/sessions/SessionRoutes'
import cajasRoutes from '../modules/cajas/cajasRoutes'
import clienteRoutes from '../modules/cliente/clienteRoutes'
import cotizacionRoutes from '../modules/cotizacion/cotizacionRoutes'
import homeRoutes, { homeRoutesMap } from '../modules/home/HomeRoutes'
import reporteRoutes from '../modules/reporte/reporteRoutes'
import ventaRoutes from '../modules/venta/ventaRoutes'
import ventaCreditoRoutes from '../modules/ventaCredito/ventaCreditoRoutes'
import cuentasPagarRoutes from '../modules/cuentas_pagar/cuentasPagarRoutes'

export const appRoutes = [
  {
    element: (
      <AuthGuard>
        <OperacionesProvider>
          <CajasProvider>
            <MatxLayout />
          </CajasProvider>
        </OperacionesProvider>
      </AuthGuard>
    ),
    children: [
      ...homeRoutes,
      ...cuentaRoutes,
      ...ventaRoutes,
      ...ventaCreditoRoutes,
      ...clienteRoutes,
      ...reporteRoutes,
      ...cotizacionRoutes,
      ...cajasRoutes,
      ...cuentasPagarRoutes,
    ],
  },
  ...sessionRoutes,
  { path: '/', element: <Navigate to={homeRoutesMap.home.path} /> },
  { path: '*', element: <NotFound /> },
]
